/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhEdward.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhEdward extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="ZhEdward-view">
        <Helmet>
          <title>創辦人 - 賴鈞豪 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="ZhEdward-first">
          <Link to="/ZhTeam">
            <div className="ZhEdward-back">
              <div className="ZhEdward-backBtn"></div>
              <div className="ZhEdward-backText">返回</div>
            </div>
          </Link>

          <div className="ZhEdwardContainer">
            <div className="ZhEdward-edwardPic" />

            <div className="ZhEdward-name">
              <strong>賴鈞豪 Edward Lai</strong>
              <br />
              創辦人、行政總裁兼首席設計師
            </div>
          </div>
        </div>

        <div className="ZhEdward-second">
          <div className="ZhEdward-secondText">
            賴鈞豪 Edward Lai 是 CheckPlus 的創辦人、行政總裁兼首席設計師。
            <p />
            在成立 CheckPlus 之前，Edward 曾在澳洲和美國生活和學習。
            他決定回到香港，為他多年來積累的知識和技能做出貢獻。
            <p />
            Edward 將大部分時間投放在與許多香港非牟利機構緊密合作上，他希望透過
            CheckPlus 向非牟利機構提供技術解決方案，回饋社區。
            <p />
            在 2019 年，他與香港的許多非牟利機構會面，而 CheckPlus
            網上捐款平台已被 30 多間非牟利機構使用。
            <p />
            Edward 獲得了加州大學聖巴巴拉分校 (University of California, Santa
            Barbara) 的社會學學士學位。
          </div>
        </div>

        <div className="ZhEdward-footer">
          <div className="ZhEdward-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhEdward-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhEdward-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhEdward-footerNavItem">聯絡我們</div>
            </Link>

            <Link to="/ZhPrivacyPolicy">
              <div className="ZhEdward-footerNavItem">私隱政策</div>
            </Link>

            <Link to="/ZhTerms">
              <div className="ZhEdward-footerNavItem">使用條款</div>
            </Link>
          </div>

          <div className="ZhEdward-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhEdward;
